module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_fm1"
    }
  }, [_vm._v("The Shetland Islands: A Unique History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_fm2"
    }
  }, [_vm._v("Shetland Lace: A Mystery Steeped in Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_fm3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shetland Lace: Tools & Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_fm4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Acre & Razor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c01#s01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forro Wristers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c01#s02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ayre Wristers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c01#s03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baetin Wrap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c01#s04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almark Shrug")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c01#s05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aer Cardigan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c01#s06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smooriken Pullover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Old Shale and Feather & Fan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c02#s07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tirrick Wristers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c02#s08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laebrack Ascot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c02#s09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lerwick Vest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c02#s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peerie Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c02#s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brae Yoke Pullover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c02#s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twaafald Tunics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Horseshoe & Leaf")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c03#s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Staig Scarf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c03#s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kergord Wristers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c03#s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weisdale Cardigan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c03#s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fyanna Jacket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c03#s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divvish Stole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c03#s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rimska Sweater")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_c03#s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tae Shawl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knitting Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yarn Weights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_bm3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knitting Needle Size Chart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_sec"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/9781454711018_ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039f57ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454711018_toc.vue
// module id = 72
// module chunks = 0